export const environment = {
  production: false,
  apiUrl: "https://app-staging.kierunekbmp.pl/api/admin",
  resourceUrl: "https://kierunekbmp.pl",
  versionUrl: "https://app-staging.kierunekbmp.pl/api",
  appVersion: require('../../package.json').version 
};
